import React from "react";

const Error = ({ message }) => {
    return <p className="text-center my-5">{message}</p>;
};

export default Error;
